module.exports = __webpack_public_path__ + "fonts/AvenirLTW02-55Roman.dd0f484f05f43c281dbd7b10b4d8a526.woff";